<template>
    <div>
        <!-- eslint-disable  -->
        <div class="content-bottom">
            <div class="bottom-tab flex">
                <div class="title">价格配置：</div>
                <div class="flex tab-title">
                    <div v-for="(item,index) in tabList" :key="index">
                        <span :class="form.pagingType==item.key?' actived':''" @click="refreshOne(item.key)" >{{item.value}}</span>
                    </div>
                </div>
            </div>
            <!-- <div class="bottom_table" v-if="(form.pagingType==1||form.pagingType==2)&&isshowTab">
                <el-table
                        ref="querytableData"
                        :stripe="true"
                        :data="querytableData"
                        key="table4"
                        border
                        style="width:100%;margin-top: 20px;"
                        height="520"
                        v-loading="querylistLoading"
                >
                    <el-table-column label="服务编号">
                        <el-table-column show-overflow-tooltip width="200">
                            <template slot="header" slot-scope="scope">
                                <el-input size="mini" v-model.trim="queryform.serviceOfferId" placeholder="搜索" @blur="queryhandleSearch()" @keyup.enter.native="queryhandleSearch()"
                                          clearable @clear="queryhandleSearch()"/>
                            </template>
                            <template slot-scope="scope">
                                <span>{{scope.row.serviceOfferId || '--'}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="服务名称">
                        <el-table-column show-overflow-tooltip width="200">
                            <template slot="header" slot-scope="scope">
                                <el-input size="mini" v-model.trim="queryform.serviceName" placeholder="搜索" @blur="queryhandleSearch()" @keyup.enter.native="queryhandleSearch()" clearable @clear="queryhandleSearch()"/>
                            </template>
                            <template slot-scope="scope">
                                <span>{{scope.row.serviceName || '--'}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="计费方式">
                        <el-table-column show-overflow-tooltip width="200">
                            <template slot="header" slot-scope="scope">
                                <el-select  size="mini" v-model="queryform.settleType" @change="queryhandleSearch()">
                                    <el-option value="" label="全部"></el-option>
                                    <el-option :value="0" label="按天计算"></el-option>
                                    <el-option :value="1" label="按小时计算"></el-option>
                                </el-select>
                            </template>
                            <template slot-scope="scope">
                                <span>{{scope.row.settleType==0?'按天计算':'按小时计算'}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="">
                        <template slot="header" slot-scope="scope">
                            <span v-if="form.pagingType==1">基础价格</span>
                            <span slot="label" v-if="form.pagingType==2">会员价</span>
                        </template>
                        <el-table-column show-overflow-tooltip width="200">
                            <template slot="header" slot-scope="scope">
                                <el-input size="mini" v-model.trim="queryform.setprice" placeholder="搜索" @blur="queryhandleSearch()" @keyup.enter.native="queryhandleSearch()" clearable @clear="queryhandleSearch()"/>
                            </template>
                            <template slot-scope="scope">
                                <span v-if="scope.row.settleType==0">
                                    <span v-if="form.pagingType!=2">
                                        {{scope.row.workdayPrice||'-'}}
                                    </span>
                                    <span v-else>{{scope.row.vipWorkdayPrice||'-'}}</span>
                                </span>
                                <span v-if="scope.row.settleType==1">
                                    <span v-if="form.pagingType!=2">
                                        {{scope.row.workdayWorkHourPrice||'-'}}
                                    </span>
                                    <span v-else>{{scope.row.VipWorkdayWorkHourPrice||'-'}}</span>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="getPrice(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin: 10px;overflow: hidden">
                    <div style="float: right;" v-show="querytableData.length">
                        <el-pagination
                                @size-change="queryhandleSizeChange"
                                @current-change="queryhandleCurrentChange"
                                :current-page="queryform.pageNum"
                                :page-sizes="[10, 20, 50, 100, 200]"
                                :page-size="queryform.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="querytotal">
                        </el-pagination>
                    </div>
                </div>
            </div> -->
            <!-- <div class="bottom_table"  v-if="form.pagingType==3">
                <div class="discount flex">
                    <div class="m-r-22">所有服务取原价的</div>
                    <el-input style="width: 300px"
                              @blur="percentageTwo(editvip.customDiscount,'editvip.customDiscount')"
                              v-model.trim="editvip.customDiscount" class="m-r-22"

                    ></el-input>
                    <div>%</div>
                </div>
            </div> -->
            <div class="bottom_table"  v-if="form.pagingType==4">
                <el-table
                        ref="onetableData"
                        :stripe="true"
                        :data="onetableData"
                        border
                        style="width:100%;margin-top: 20px;"
                        height="520"
                        v-loading="onelistLoading"
                        key="table1"
                >
                    <el-table-column label="产品id"  prop="productId">
                        <template slot-scope="scope">
                            <span>{{scope.row.productId || '--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="产品名称" prop="productName">
                        <template slot-scope="scope">
                            <span>{{scope.row.productName || '--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="价格百分比" prop="customDiscount">
                        <template slot-scope="scope">
                            <el-input v-model.trim="scope.row.customDiscount"
                                      @blur="focusEvent(scope.row.customDiscount,scope.row, 'customDiscount')"
                                      style="width: 200px" class="m-r-22"></el-input>
                            <span>%</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin: 10px;overflow: hidden">
                    <div style="float: right;" v-show="onetableData.length">
                        <el-pagination
                                @size-change="onehandleSizeChange"
                                @current-change="onehandleCurrentChange"
                                :current-page="oneform.pageNum"
                                :page-sizes="[10, 20, 50, 100, 200]"
                                :page-size="oneform.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="onetotal">
                        </el-pagination>
                    </div>
                </div>
            </div>
            <div class="bottom_table" v-if="form.pagingType==5">
                <el-table
                        ref="tableData"
                        :stripe="true"
                        :data="tableData"
                        border
                        style="width:100%;margin-top: 20px;"
                        height="520"
                        key="table2"
                        v-loading="listLoading"
                >
                    <el-table-column label="服务编号">
                        <el-table-column show-overflow-tooltip width="150">
                            <template slot="header" slot-scope="scope">
                                <el-input size="mini" v-model.trim="form.serviceOfferId" placeholder="搜索" @keyup.enter.native="handleSearch()"
                                          clearable @clear="handleSearch()" @blur="handleSearch()"/>
                            </template>
                            <template slot-scope="scope">
                                <span>{{scope.row.serviceOfferId || '--'}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="服务名称">
                        <el-table-column show-overflow-tooltip width="200">
                            <template slot="header" slot-scope="scope">
                                <el-input size="mini" v-model.trim="form.serviceName" placeholder="搜索" @blur="handleSearch()" @keyup.enter.native="handleSearch()" clearable @clear="handleSearch()"/>
                            </template>
                            <template slot-scope="scope">
                                <span>{{scope.row.serviceName || '--'}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="基础价格按天">
                        <el-table-column show-overflow-tooltip width="200">
                            <template slot="header" slot-scope="scope">
                                <el-input size="mini" v-model.trim="form.workdayPrice" placeholder="搜索" @blur="handleSearch()" @keyup.enter.native="handleSearch()" clearable @clear="handleSearch()"/>
                            </template>
                            <template slot-scope="scope">
                                <span>{{scope.row.workdayPrice || '--'}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="基础价格按小时">
                        <el-table-column show-overflow-tooltip width="200">
                            <template slot="header" slot-scope="scope">
                                <el-input size="mini" v-model.trim="form.workdayWorkHourPrice" placeholder="搜索" @blur="handleSearch()" @keyup.enter.native="handleSearch()" clearable @clear="handleSearch()"/>
                            </template>
                            <template slot-scope="scope">
                                <span>{{scope.row.workdayWorkHourPrice || '--'}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="专属价格按天">
                        <el-table-column show-overflow-tooltip width="200">
                            <template slot="header" slot-scope="scope">
                                <el-input size="mini" v-model.trim="form.exclusiveWorkdayPrice" placeholder="搜索" @blur="handleSearch()" @keyup.enter.native="handleSearch()" clearable @clear="handleSearch()"/>
                            </template>
                            <template slot-scope="scope">
                                <span>{{scope.row.exclusiveWorkdayPrice || '--'}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="专属价格按小时">
                        <el-table-column show-overflow-tooltip width="200">
                            <template slot="header" slot-scope="scope">
                                <el-input size="mini" v-model.trim="form.exclusiveWorkdayWorkHourPrice" placeholder="搜索" @blur="handleSearch()" @keyup.enter.native="handleSearch()" clearable @clear="handleSearch()"/>
                            </template>
                            <template slot-scope="scope">
                                <span>{{scope.row.exclusiveWorkdayWorkHourPrice || '--'}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>





                    <!-- <el-table-column label="计费方式">
                        <el-table-column show-overflow-tooltip width="200">
                            <template slot="header" slot-scope="scope">
                                <el-select  size="mini" v-model="form.settleType" @change="handleSearch()">
                                    <el-option value="" label="全部"></el-option>
                                    <el-option :value="0" label="按天计算"></el-option>
                                    <el-option :value="1" label="按小时计算"></el-option>
                                </el-select>
                            </template>
                            <template slot-scope="scope">
                                <span>{{scope.row.settleType==0?'按天计算':'按小时计算'}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column> -->
                    <!-- <el-table-column label="基础价格">
                        <el-table-column show-overflow-tooltip width="200">
                            <template slot="header" slot-scope="scope">
                                <el-input size="mini" v-model.trim="form.setprice" placeholder="搜索" @blur="handleSearch()" @keyup.enter.native="handleSearch()" clearable @clear="handleSearch()"/>
                            </template>
                            <template slot-scope="scope">
                                <span v-if="scope.row.settleType==0">
                                    <span v-if="form.pagingType!=2">
                                        <span v-if="scope.row.workdayPrice||scope.row.workdayPrice==0">{{scope.row.workdayPrice}}</span>
                                        <span v-else>-</span>
                                    </span>
                                    <span v-else>
                                         <span v-if="scope.row.vipWorkdayPrice||scope.row.vipWorkdayPrice==0">{{scope.row.vipWorkdayPrice}}</span>
                                         <span v-else>-</span>
                                    </span>
                                </span>
                                <span v-if="scope.row.settleType==1">
                                    <span v-if="form.pagingType!=2">
                                         <span v-if="scope.row.workdayWorkHourPrice||scope.row.workdayWorkHourPrice==0">{{scope.row.workdayWorkHourPrice}}</span>
                                         <span v-else>-</span>
                                    </span>
                                    <span v-else>
                                         <span v-if="scope.row.VipWorkdayWorkHourPrice||scope.row.VipWorkdayWorkHourPrice==0">{{scope.row.VipWorkdayWorkHourPrice}}</span>
                                         <span v-else>-</span>
                                    </span>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table-column> -->
                    <!-- <el-table-column label="专属价格">
                        <el-table-column show-overflow-tooltip width="200">
                            <template slot="header" slot-scope="scope">
                                <el-input size="mini" v-model.trim="form.exclusiveWorkPrice" placeholder="搜索" @blur="handleSearch()" @keyup.enter.native="handleSearch()"
                                          clearable @clear="handleSearch()"/>
                            </template>
                            <template slot-scope="scope">
                                <span v-if="scope.row.exclusiveSettleType==0">
                                     <span v-if="scope.row.exclusiveWorkdayPrice||scope.row.exclusiveWorkdayPrice==0">{{scope.row.exclusiveWorkdayPrice}}</span>
                                     <span v-else>-</span>
                                </span>
                                <span v-else-if="scope.row.exclusiveSettleType==1">
                                     <span v-if="scope.row.exclusiveWorkdayWorkHourPrice||scope.row.exclusiveWorkdayWorkHourPrice==0">{{scope.row.exclusiveWorkdayWorkHourPrice}}</span>
                                     <span v-else>-</span>
                                </span>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                    </el-table-column> -->
                    <el-table-column label="操作" fixed="right">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="openService(scope.row)">设置</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin: 10px;overflow: hidden">
                    <div style="float: right;" v-show="tableData.length">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="form.pageNum"
                                :page-sizes="[10, 20, 50, 100, 200]"
                                :page-size="form.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <service-settings
                ref="serviceSettings"
                v-if="showService"
                :current-param="serviceParam"
                @close="closeService"
                @refreshList="successService"
        ></service-settings>
        <el-dialog
                title=""
                :visible.sync="ShowPrice"
                :close-on-click-modal="false"
                width="750px"
                ref="dialog"
                @close="PriceClose"
        >
            <div class="Query-price" v-if="VipPriceInfo&&billDay">
                <el-row>
                    <el-col :span="12" v-if="form.pagingType!=2">
                        <div>
                            <span class="span_inblock">工作日价格</span>
                            <span>{{billDay.workdayPrice}}元 / 天 / 人</span>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <span class="span_inblock">工作日会员价</span>
                        <span>{{billDay.vipWorkdayPrice}}元 / 天 / 人</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" v-if="form.pagingType!=2">
                        <div>
                            <span class="span_inblock">周末价格</span>
                            <span>{{billDay.weekendPrice}}元 / 天 / 人</span>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div>
                            <span class="span_inblock">周末会员价</span>
                            <span>{{billDay.vipWeekendPrice}}元 / 天 / 人</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" v-if="form.pagingType!=2">
                        <div>
                            <span class="span_inblock">节假日价格</span>
                            <span>{{billDay.holidayPrice}}元 / 天 / 人</span>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div>
                            <span class="span_inblock">节假日会员价</span>
                            <span>{{billDay.vipHolidayPrice}}元 / 天 / 人</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">工作日加班价格</span>
                            <span>
                                <el-radio>{{billDay.isWorkdayHasOvertimeSetting?'有':'无'}}</el-radio>
                                <span v-if="billDay.isWorkdayHasOvertimeSetting">{{billDay.workdayOverTimeBefore}}以前，{{billDay.workdayOverTimeAfter}}以后，
                                    加班价格{{billDay.workdayOverTimeHourPrice}}元 / 天 / 人</span>
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">周末加班价格</span>
                            <span>
                                <el-radio>{{billDay.isWeekendHasOvertimeSetting?'有':'无'}}</el-radio>
                                <span v-if="billDay.isWeekendHasOvertimeSetting">{{billDay.weekendOverTimeBefore}}以前，{{billDay.weekendOverTimeAfter}}以后，
                                    加班价格{{billDay.weekendOverTimeHourPrice}}元 / 天 / 人</span>
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">节假日加班价格</span>
                            <span>
                               <el-radio>{{billDay.isHolidayHasOvertimeSetting?'有':'无'}}</el-radio>
                                <span v-if="billDay.isHolidayHasOvertimeSetting">{{billDay.holidayOverTimeBefore}}以前，
                                    {{billDay.holidayOverTimeAfter}}以后，
                                    加班价格{{billDay.holidayOverTimeHourPrice}}元 / 天 / 人</span>
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">同城补助</span>
                            <span><el-radio>{{bzSwitch(billDay.citySubsidy)}}</el-radio></span>
                            <span v-if="billDay.citySubsidy==4" class="mar-l-22"> {{billDay.cityFixedSubsidy}}元/天/人</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">异地补助</span>
                            <span><el-radio>{{bzSwitch(billDay.diffCitySubsidy)}}</el-radio></span>
                            <span v-if="billDay.diffCitySubsidy==4" class="mar-l-22"> {{billDay.diffCityFixedSubsidy}}元/天/人</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">发单方价格</span>
                            <span><el-radio>{{billDay.isTaxIncluded?'含税':'不含税'}}</el-radio></span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">特殊地区涨幅</span>
                            <span><el-radio>增长{{billDay.specialPlaceIncreaseRate}}%</el-radio></span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">特殊地区</span>
                            <span v-for="(item,index) in billDay.specialPlace" :key="index">
                                        {{item.cityName || item.provinceName}}
                                         <span v-if="billDay.specialPlace.length>1&&billDay.specialPlace.length-index>1">、</span>
                                     </span>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="Query-price" v-if="VipPriceInfo&&billHour">
                <el-row v-if="form.pagingType!=2">
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">工作日价格</span>
                            <span>出发{{billHour.workdayDepartHourPrice}}元/小时/人，
                                               工作{{billHour.workdayWorkHourPrice}}元/小时/人，
                                               返程{{billHour.workdayBackHourPrice}}元/小时/人
                                         </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="form.pagingType!=2">
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">周末价格</span>
                            <span>出发{{billHour.weekendDepartHourPrice}}元/小时/人，
                                               工作{{billHour.weekendWorkHourPrice}}元/小时/人，
                                               返程{{billHour.weekendBackHourPrice}}元/小时/人
                                         </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="form.pagingType!=2">
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">节假日价格</span>
                            <span>出发{{billHour.workdayDepartHourPrice}}元/小时/人，
                                               工作{{billHour.workdayWorkHourPrice}}元/小时/人，
                                               返程{{billHour.workdayBackHourPrice}}元/小时/人
                                         </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">工作日会员价</span>
                            <span>出发{{billHour.vipWorkdayDepartHourPrice}}元/小时/人，
                                               工作{{billHour.vipWorkdayWorkHourPrice}}元/小时/人，
                                               返程{{billHour.vipWorkdayBackHourPrice}}元/小时/人
                                         </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">周末会员价</span>
                            <span>出发{{billHour.vipWeekendDepartHourPrice}}元/小时/人，
                                               工作{{billHour.vipWeekendWorkHourPrice}}元/小时/人，
                                               返程{{billHour.vipWeekendBackHourPrice}}元/小时/人
                                         </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">节假日会员价</span>
                            <span>出发{{billHour.vipHolidayDepartHourPrice}}元/小时/人，
                                               工作{{billHour.vipHolidayWorkHourPrice}}元/小时/人，
                                               返程{{billHour.vipHolidayBackHourPrice}}元/小时/人
                                         </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">工作日加班价格</span>
                            <span>
                                <el-radio>{{billHour.isWorkdayHasOvertimeSetting?'有':'无'}}</el-radio>
                                  <span v-if="billHour.isWorkdayHasOvertimeSetting">{{billHour.workdayOverTimeBefore}}以前，{{billHour.workdayOverTimeAfter}}以后，
                                         每小时{{billHour.workdayOverTimeHourPrice }}元/小时</span>
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">周末加班价格</span>
                            <span>
                                <el-radio>{{billHour.isWeekendHasOvertimeSetting?'有':'无'}}</el-radio>
                                 <span v-if="billHour.isWeekendHasOvertimeSetting">{{billHour.weekendOverTimeBefore }}以前，{{billHour.weekendOverTimeAfter }}以后，
                                     每小时{{billHour.weekendOverTimeHourPrice}}元/小时</span>
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">节假日加班价格</span>
                            <span>
                               <el-radio>{{billHour.isHolidayHasOvertimeSetting?'有':'无'}}</el-radio>
                               <span v-if="billHour.isHolidayHasOvertimeSetting">
                                         {{billHour.holidayOverTimeBefore}}以前，{{billHour.holidayOverTimeAfter}}以后，
                                     每小时{{billHour.holidayOverTimeHourPrice}}元/小时</span>
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <span class="span_inblock">扣除1小时价格：</span>
                        <span v-if="billHour.isDeductOneHourPrice">{{billHour.deductionOneHourBTime}}~{{billHour.deductionOneHourETime}}</span>
                        <span v-else>否</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">同城补助</span>
                            <span><el-radio>{{bzSwitch(billHour.citySubsidy)}}</el-radio></span>
                            <span v-if="billHour.citySubsidy==4" class="mar-l-22"> {{billHour.cityFixedSubsidy}}元/天/人</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">异地补助</span>
                            <span><el-radio>{{bzSwitch(billHour.diffCitySubsidy)}}</el-radio></span>
                            <span v-if="billHour.diffCitySubsidy==4" class="mar-l-22"> {{billHour.diffCityFixedSubsidy}}元/天/人</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">发单方价格</span>
                            <span><el-radio>{{billHour.isTaxIncluded?'含税':'不含税'}}</el-radio></span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">特殊地区涨幅</span>
                            <span><el-radio>增长{{billHour.specialPlaceIncreaseRate}}%</el-radio></span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div>
                            <span class="span_inblock">特殊地区</span>
                            <span v-for="(item,index) in billHour.specialPlace" :key="index">
                                        {{item.cityName || item.provinceName}}
                                         <span v-if="billHour.specialPlace.length>1&&billHour.specialPlace.length-index>1">、</span>
                                     </span>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { updateCustomDiscount,updateVipPrimaryPriceConf,servicePricePagAll,primaryProductPricingSettings,
        servicePricePag,enterpriseVipPriceQuiry} from "@/service/customerInformation";
    import serviceSettings from "./serviceSettings";
    export default {
        name: "priceAllocation",
        props:{
            currentParam:{
                type:Object,
                default(){return {}}
            }
        },
        components:{
            serviceSettings
        },
        data(){
            return{
                form:{
                    serviceOfferId:'',
                    pageNum: 1,
                    pageSize: 10,
                    serviceName:'',
                    settleType:'',
                    pagingType:1,
                    setprice:'',
                    exclusiveWorkPrice:'',

                    workdayPrice: '',                   //基础价格按天
                    workdayWorkHourPrice: '',           //基础价格按小时
                    exclusiveWorkdayPrice: '',          //专属价格按天
                    exclusiveWorkdayWorkHourPrice: '',  //专属价格按小时
                },
                tableData:[],
                listLoading:false,
                total:0,
                searchData:{},
                oraginForm:{},
                tabList:[
                    {key:'1',value:'标准价'},
                    // {key:'2',value:'会员价'},
                    // {key:'3',value:'自定义折扣'},
                    {key:'4',value:'二级产品定价'},
                    {key:'5',value:'服务定价'},
                ],
                editvip:{
                    customDiscount:''
                },
                //一级产品定价
                onetableData:[],
                onelistLoading:false,
                oneform:{
                    pageNum: 1,
                    pageSize: 10,
                },
                onesearchData:{},
                onetotal:0,
                vipinfo:{
                    id:''
                },
                //服务设置
                showService:false,
                serviceParam:{},
                newparam:{},
                //标准价，会员价
                queryform:{
                    serviceOfferId:'',
                    pageNum: 1,
                    pageSize: 10,
                    serviceName:'',
                    settleType:'',
                    setprice:''
                },
                querytotal:0,
                querytableData:[],
                querysearchData:{},
                queryoraginForm:{},
                querylistLoading:false,
                //查看价格
                ShowPrice:false,
                VipPriceInfo:{},
                billHour:{},
                billDay:{},
                isshowTab:false
            }
        },
        methods:{
            focusEvent(data,row,key){
                var o = data.replace(/,/gi, '')
                let rate = 1;
                o = Number(o)
                if (isNaN(o) || parseInt(o) < 1) {
                    rate = 1;
                } else if (parseInt(o) >= 10000) {
                    rate = 10000;
                } else {
                    rate = Math.floor( o * 100) / 100
                }
                row[key] = rate;
                this.changeoneLevelPrice(rate,row)
            },
            // percentageTwo(data,name){
            //     let arr =name.split('.');
            //     let o = data.replace(/,/gi, '')
            //     let rate = 1;
            //     o = Number(o)
            //     if (isNaN(o) || parseInt(o) < 1) {
            //         rate = 1;
            //     } else if (parseInt(o) >= 100) {
            //         rate = 100;
            //     } else {
            //         rate = Math.floor( o * 100) / 100
            //     }
            //     // 重新赋值转换后的值
            //     this[arr[0]][arr[1]] = rate;
            //     this.changePercentage();
            // },
            refreshOne(key){
                this.form.pagingType=key;
                // if(key==1||key==2) return
                if(this.form.pagingType==1||this.form.pagingType==2){
                    if(this.isshowTab){
                        this.queryoraginForm = JSON.parse(JSON.stringify(this.queryform))
                        this.querytableData = [];
                        this.queryhandleSearch();
                    }
                }
                if (this.form.pagingType==5){
                    this.oraginForm = JSON.parse(JSON.stringify(this.form))
                    this.tableData = [];
                    this.handleSearch();
                }
                if(this.form.pagingType==4){
                    this.onetableData = [];
                    this.onehandleSearch();
                }
            },
            //修改自定义
            // changePercentage(){
            //     let companyId=Number(this.$route.query.companyId);
            //     let param = {
            //         companyId:companyId,
            //         enterpriseVipConfId:this.vipinfo.id,
            //         discount:this.editvip.customDiscount
            //     }
            //     updateCustomDiscount(param).then((res)=>{
            //         if (res.Result != 1) {
            //             return this.$message.error("修改失败")
            //         }
            //         this.$message.success("修改成功")
            //         // this.getVipInfo()
            //     })
            // },
            //一级产品定价
            changeoneLevelPrice(rate,row){
                let companyId=Number(this.$route.query.companyId);
                let param = {
                    companyId:companyId,
                    productId:row.productId,
                    productName:row.productName,
                    enterpriseVipConfId:this.vipinfo.id,
                    discount:rate
                }
                updateVipPrimaryPriceConf(param).then((res)=>{
                    if (res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success("修改成功");
                    this.onetableData = [];
                    this.onehandleSearch();
                })
            },
            async getprimaryPrice(){
                let companyId=Number(this.$route.query.companyId);
                this.onelistLoading = true;
                let data = JSON.parse(JSON.stringify(this.onesearchData));
                data.enterpriseVipConfId = this.vipinfo.id;
                data.companyId = companyId;
                let res = await primaryProductPricingSettings(data)
                this.onelistLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.onetableData = res.Data.datas || [];
                this.onetotal = res.Data.total;
                this.$nextTick(() => {
                    this.$refs.onetableData.doLayout()
                })
            },
            onehandleSearch(){
                this.onesearchData = Object.assign({}, this.oneform)
                this.oneform.pageNum = 1;
                this.getprimaryPrice();
            },
            onehandleSizeChange(val){
                if (this.onelistLoading) return
                this.oneform.pageNum = 1
                this.oneform.pageSize = val;
                this.onesearchData.pageNum = 1
                this.onesearchData.pageSize = val;
                this.getprimaryPrice();
            },
            onehandleCurrentChange(val){
                if (this.onelistLoading) return
                this.oneform.pageNum = val;
                this.onesearchData.pageNum = val;
                this.getprimaryPrice();
            },
            //配置
            async getServicePricePagAll(){
                let companyId=Number(this.$route.query.companyId);
                this.listLoading = true;
                let data = JSON.parse(JSON.stringify(this.searchData))
                !data.serviceOfferId && delete data.serviceOfferId
                !data.serviceName && delete data.serviceName
                !data.exclusiveWorkPrice && delete data.exclusiveWorkPrice
                data.enterpriseVipConfId = this.vipinfo.id
                data.companyId = companyId
                if(data.setprice){
                    if(this.form.settleType==0){
                        data.workdayPrice = this.form.setprice
                    }
                    if(this.form.settleType==1){
                        data.workdayWorkHourPrice = this.form.setprice
                    }
                }
                !data.setprice && delete data.setprice
                let res = await servicePricePagAll(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.datas || [];
                this.total = res.Data.total;
                this.$nextTick(() => {
                    this.$refs.tableData.doLayout()
                })
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.pageNum = 1
                this.form.pageSize = val;
                this.searchData.pageNum = 1
                this.searchData.pageSize = val;
                this.getServicePricePagAll();
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.pageNum = val;
                this.searchData.pageNum = val;
                this.getServicePricePagAll();
            },
            handleSearch(){
                this.searchData = Object.assign({}, this.form)
                this.form.pageNum = 1;
                this.searchData.pageNum = 1;
                this.getServicePricePagAll();
            },
            //服务设置
            closeService() {
                this.showService=false
            },
            successService(){
                this.oraginForm = JSON.parse(JSON.stringify(this.form))
                this.tableData = [];
                this.handleSearch();
            },
            openService(data){
                let param = {
                    enterpriseVipConfId:this.vipinfo.id,
                    pagingType:this.form.pagingType,
                    serviceOfferId:data.serviceOfferId
                    // confPriceId:data.confPriceId
                }
                this.serviceParam = param;
                this.showService=true;
            },
            //标准价、会员价
            // async getservicePricePag(){
            //     let companyId=Number(this.$route.query.companyId);
            //     this.querylistLoading = true;
            //     let data = JSON.parse(JSON.stringify(this.querysearchData))
            //     !data.serviceOfferId && delete data.serviceOfferId
            //     !data.serviceName && delete data.serviceName
            //     data.enterpriseVipConfId = this.vipinfo.id
            //     data.companyId = companyId
            //     data.pagingType = this.form.pagingType
            //     if(data.setprice){
            //         if(this.queryform.settleType==0){
            //             data.workdayPrice = this.queryform.setprice
            //         }
            //         if(this.queryform.settleType==1){
            //             data.workdayWorkHourPrice = this.queryform.setprice
            //         }
            //     }
            //     delete data.setprice
            //     let res = await servicePricePag(data)
            //     this.querylistLoading = false
            //     if(res.Result != 1) {
            //         return this.$message.error('获取失败请联系开发人员')
            //     }
            //     this.querytableData = res.Data.datas || [];
            //     this.querytotal = res.Data.total;
            //     this.$nextTick(() => {
            //         this.$refs.querytableData.doLayout()
            //     })
            // },
            // queryhandleSizeChange(val) {
            //     if (this.listLoading) return
            //     this.queryform.pageNum = 1
            //     this.queryform.pageSize = val;
            //     this.querysearchData.pageNum = 1
            //     this.querysearchData.pageSize = val;
            //     this.getservicePricePag();
            // },
            // queryhandleCurrentChange(val) {
            //     if (this.listLoading) return
            //     this.queryform.pageNum = val;
            //     this.querysearchData.pageNum = val;
            //     this.getservicePricePag();
            // },
            // queryhandleSearch(){
            //     this.querysearchData = Object.assign({}, this.queryform)
            //     this.queryform.pageNum = 1;
            //     this.querysearchData.pageNum = 1;
            //     this.getservicePricePag();
            // },
            //查看价格
            PriceClose(){
                this.ShowPrice=false
            },
            getPrice(data){
                let companyId=Number(this.$route.query.companyId);
                let param = {
                    companyId:companyId,
                    enterpriseVipConfId:this.vipinfo.id,
                    pagingType:this.form.pagingType,
                    serviceOfferId:data.serviceOfferId
                }
                enterpriseVipPriceQuiry(param).then((res)=>{
                    if(res.Result != 1) {
                        return this.$message.error('获取失败请联系开发人员')
                    }
                    if(!res.Data.billConfigurationDay&&!res.Data.billConfigurationHour){
                        return this.$message.warning('暂无数据')
                    }
                    this.VipPriceInfo = res.Data;
                    this.billDay = res.Data.billConfigurationDay;
                    this.billHour = res.Data.billConfigurationHour;
                    this.ShowPrice=true;
                })
            },
            bzSwitch(val){
                let content=''
                switch (val) {
                    case 1:
                        content = '无补助';
                        break;
                    case 2:
                        content = '实报实销';
                        break;
                    case 3:
                        content = '速派规则';
                        break;
                    case 4:
                        content = '固定补助';
                        break;
                }
                return content
            },
            getSetParam(){
                if (this.currentParam){
                    const param = JSON.parse(JSON.stringify(this.currentParam));
                    this.newparam = param;
                    this.form.pagingType = this.newparam.priceAllocation;
                    this.editvip.customDiscount = this.newparam.customDiscount;
                    // this.vipinfo.id = this.newparam.id;
                    this.vipinfo.id = this.newparam.enterpriseVipConfId;
                    this.isshowTab = this.newparam.isshowTab;
                    this.$nextTick(()=>{
                        if (this.form.pagingType==5){
                            this.oraginForm = JSON.parse(JSON.stringify(this.form))
                            this.tableData = [];
                            this.handleSearch();
                        }
                        if(this.form.pagingType==4){
                            this.onetableData = [];
                            this.onehandleSearch();
                        }
                        if(this.form.pagingType==1||this.form.pagingType==2){
                            if (this.isshowTab){
                                this.queryoraginForm = JSON.parse(JSON.stringify(this.queryform))
                                this.querytableData = [];
                                this.queryhandleSearch();
                            }
                        }
                    })
                }
            },
        },
        activated() {
            if (this.currentParam){
                const param = JSON.parse(JSON.stringify(this.currentParam));
                this.newparam = param;
                this.form.pagingType = this.newparam.priceAllocation;
                this.editvip.customDiscount = this.newparam.customDiscount;
                // this.vipinfo.id = this.newparam.id;
                this.vipinfo.id = this.newparam.enterpriseVipConfId;
                this.isshowTab = this.newparam.isshowTab;
                if (this.form.pagingType==5){
                    this.oraginForm = JSON.parse(JSON.stringify(this.form))
                    this.tableData = [];
                    this.handleSearch();
                }
                if(this.form.pagingType==4){
                    this.onetableData = [];
                    this.onehandleSearch();
                }
                if(this.form.pagingType==1||this.form.pagingType==2){
                    if (this.isshowTab){
                        this.queryoraginForm = JSON.parse(JSON.stringify(this.queryform))
                        this.querytableData = [];
                        this.queryhandleSearch();
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    .content-bottom{
        .bottom-tab{
            // width: 1056px;
            width: 1250px;
            background: #F9F9F9;
            border: 1px solid #E5E5E5;
            padding: 25px 0;
            padding-left: 21px;
            box-sizing: border-box;
            .title{
                font-size: 16px;
                font-weight: 400;
                color: #666666;
                align-items: center;
                display: flex;
            }
            .tab-title{
                font-size: 14px;
                font-weight: 400;
                color: #999999;
                align-items: center;
                div{
                    cursor: pointer;
                    margin: 0px 0px 0px 50px;
                }
                .actived{
                    padding: 6px 20px;
                    background: #2D8CF0;
                    border-radius: 2px;
                    color: #FFFFFF;
                }
            }
        }
        .bottom_table{
            width: 1250px;
            .el-table td, .el-table th{
                padding: 7px 0px!important;
            }
            .discount{
                padding:20px;
                align-items:center;
            }
            .m-r-22{
                margin-right: 22px;
            }
        }
        .flex{
            display: flex;
        }
    }
    .Query-price{
        font-size: 16px;
        .el-row{
            margin-bottom: 20px;
        }
        .span_inblock{
            width: 150px;
            display: inline-block;
        }

    }
</style>
